import Gif from "../../../assets/img/projects/Effet_Mer/11677207.mp4";

function App() {
  return (
    <div className="Effet_Mer-gif">
      <video
        className="ImgGif"
        src={Gif}
        alt="Effet_Mer Gif"
        autoPlay
        loop
        muted
        playsInline
      />
    </div>
  );
}

export default App;
